if (!customElements.get('video-slideshow')) {
  const sleep = (t) => new Promise(resolve => {
    setTimeout(resolve, t);
  });
  
  class VideoSlideshow extends HTMLElement {
    constructor() {
      super();
      this.videoListItem = this.querySelectorAll('.video-list-item[data-index]');
      this.videoList = this.querySelector('.video-list');
      this.firstVideoListItem = this.querySelector('.video-list-item');
      this.nextBtn = this.querySelector('[name="next"]');
      this.prevBtn = this.querySelector('[name="prev"]');
      this.contentBox = this.querySelectorAll('.video-list-item__content_box');
      this.tags = this.querySelectorAll('.video-slideshow-tags-item');
      this.isMove = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.index = 1;
      this._scrollWidth = this.videoList.scrollWidth;
      this.isLock = false;
      this.init();
      this.bindEvent();
    }

    lock() {
      this.isLock = true;
      setTimeout(() => {
        this.isLock = false;
      }, 400)
    }

    async init() {
      await sleep(500);

      for (let i = 0; i < this.videoListItem.length; i++) {
        const $item = this.videoListItem[i];
        const { offsetLeft } = $item;
        const { scrollWidth } = this.videoList;
        const itemWidth = parseFloat(getComputedStyle($item).width);
        const contentWidth = parseFloat(getComputedStyle(this.videoList).width);
        const positionX = offsetLeft - (contentWidth - itemWidth) / 2;

        console.log('itemWidth', itemWidth)

        if (!itemWidth) {
          return await this.init();
        }

        $item.setAttribute('data-offset-left', offsetLeft);
        $item.setAttribute('data-item-width', itemWidth);
        $item.setAttribute('data-position-x', positionX);
        $item.setAttribute('data-content-width', contentWidth);
        $item.setAttribute('data-scroll-width', scrollWidth);
      }

      this.move(this.index);
    }

    bindEvent() {
      this.nextBtn.addEventListener('click', this.next.bind(this, this.nextBtn));
      this.prevBtn.addEventListener('click', this.prev.bind(this, this.prevBtn));
      for (let i = 0; i < this.tags.length; i++) {
        const $item = this.tags[i];
        $item.addEventListener('click', this.switchTab.bind(this, $item))
      }
    }

    switchTab($target) {
      const index = $target.getAttribute('data-index');
      this.index = index;
      this.move(index);
      for (let i = 0; i < this.tags.length; i++) {
        const $item = this.tags[i];
        $item.classList.remove('active');
      }
      this.querySelector(`.video-slideshow-tags-item[data-index="${ index }"]`).classList.add('active');
    }

    async next() {
      if (this.isLock) return;
      
      this.lock();
      
      this.index++;

      this.move(this.index);

      console.log('this.index', this.index, 'this.videoListItem.length', this.videoListItem.length);

      if (this.index >= this.videoListItem.length - 1) {
        await sleep(200);
        
        this.videoList.classList.remove('animate');

        this.index = 1;

        this.move(this.index);

        await sleep(200);

        this.videoList.classList.add('animate');
      }
      
      for (let i = 0; i < this.tags.length; i++) {
        const $item = this.tags[i];
        $item.classList.remove('active');
      }
      
      this.querySelector(`.video-slideshow-tags-item[data-index="${ this.index }"]`).classList.add('active');
    }

    async prev() {
      if (this.isLock) return;
      
      this.lock();
      
      this.index--;
      
      this.move(this.index);

      if (this.index <= 0) {
        await sleep(200);
        
        this.videoList.classList.remove('animate');

        this.index = this.videoListItem.length - 2;

        this.move(this.index);

        await sleep(200);

        this.videoList.classList.add('animate');
      }
      
      for (let i = 0; i < this.tags.length; i++) {
        const $item = this.tags[i];
        $item.classList.remove('active');
      }
      
      this.querySelector(`.video-slideshow-tags-item[data-index="${ this.index }"]`).classList.add('active');
    }

    move(index) {
      const x = this.querySelector(`.video-list-item[data-index="${ index }"]`).getAttribute('data-position-x');

      this.videoList.style.transform = `translateX(${ -x }px)`;

      this.setStatus();
    }

    setStatus() {
      console.log('setStatus');
      for (let i = 0; i < this.videoListItem.length; i++) {
        const $item = this.videoListItem[i];
        $item.classList.remove('active');
        if ($item.querySelector('.media')) $item.querySelector('.media').classList.remove('hidden');
        if (i === this.index) {
          try {
            if ($item.querySelector('video')) $item.querySelector('video').play();
            if ($item.querySelector('iframe')) $item.querySelector('iframe').click();
          } catch(err) {}
        } else {
          try {
            if ($item.querySelector('video')) $item.querySelector('video').pause();
            if ($item.querySelector('iframe')) $item.querySelector('iframe').click();
          }catch(err) {}
        }
      }
      this.querySelector(`.video-list-item[data-index="${ this.index }"]`).classList.add('active');
      if (this.querySelector(`.video-list-item[data-index="${ this.index }"]`).querySelector('.media')) this.querySelector(`.video-list-item[data-index="${ this.index }"]`).querySelector('.media').classList.add('hidden');
    }
  }

  customElements.define('video-slideshow', VideoSlideshow);
}